import PlatformError from "../PlatformError";

export default new PlatformError(
  "ERROR",
  "Your browser window height was determined to be too low for this study",
  "Screenout",
  "User failed viewport height check",
  "app.start.viewportheight"
);
